import * as modules from "./modules/";
import config from "../../../../../config";

const { vendor } = config;

const Switch = modules[vendor] ? modules[vendor] : modules["default"];

export default Switch;
